import { ReactNode, createContext, useContext } from 'react';
import Yup from '../../../utils/yup';

interface PropTypes {
  schema: Yup.SchemaObjectDescription | undefined;
  children?: ReactNode;
}

const useSchemaContext = createContext<Yup.SchemaObjectDescription | undefined>(
  undefined,
);

const SchemaProvider = ({ schema, children }: PropTypes) => (
  <useSchemaContext.Provider value={schema}>
    {children}
  </useSchemaContext.Provider>
);

const useSchema = () => {
  const context = useContext(useSchemaContext);

  if (!context) {
    console.error('Contexto do schema com erro.');
    return;
  }

  return context;
};

export { SchemaProvider, useSchema };
